import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import API from '@/api/client';
import { setToken, setUser } from '@/utils/storage';
import { toast } from 'sonner';

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: sessionStorage.getItem('demo_email') || '',
    password: sessionStorage.getItem('demo_password') || '',
  });

  // Clear session storage after using it
  React.useEffect(() => {
    if (sessionStorage.getItem('demo_email')) {
      sessionStorage.removeItem('demo_email');
      sessionStorage.removeItem('demo_password');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await API.post('/auth/login', formData);
      const { access_token, user } = response.data;

      setToken(access_token);
      setUser(user);
      toast.success('Login successful!');

      // Navigate based on role
      if (user.role === 'super_admin' || user.role === 'admin' || user.role === 'ops_manager') {
        navigate('/admin/dashboard');
      } else if (user.role === 'therapist') {
        navigate('/therapist/dashboard');
      } else if (user.role === 'customer') {
        navigate('/customer/dashboard');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4">
      <Card className="w-full max-w-md p-8 shadow-lg">
        <div className="mb-8 text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_e65b2a0c-b7a8-46e9-8a92-d5df4207b5ae/artifacts/8vn39jol_Physiomobile%20Logo.jpeg"
            alt="Physiomobile Logo"
            className="h-16 mx-auto mb-6"
          />
          <h1 className="font-heading text-3xl font-bold text-gray-800">
            Flywheel Engine
          </h1>
          <p className="text-muted-foreground mt-2">Sign in to your account</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email" className="font-subheading text-sm font-medium text-gray-700">
              Email
            </Label>
            <Input
              id="email"
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              className="mt-1"
              data-testid="login-email-input"
            />
          </div>

          <div>
            <Label htmlFor="password" className="font-subheading text-sm font-medium text-gray-700">
              Password
            </Label>
            <Input
              id="password"
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              className="mt-1"
              data-testid="login-password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full"
            data-testid="login-submit-button"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>

        <div className="mt-6 text-center text-sm text-muted-foreground">
          <p>Demo Credentials:</p>
          <p className="font-mono text-xs mt-2">
            Admin: admin@physiomobile.com / admin123<br />
            Therapist: therapist1@physiomobile.com / therapist123<br />
            Customer: customer1@example.com / customer123
          </p>
        </div>
      </Card>
    </div>
  );
};

export default Login;